import { c as _c } from "react/compiler-runtime";
import { LabeledSelect } from '../labeled-select';
interface FacetSelectProps {
  categoryLabel: string;
  value: string;
  onValueChange: (value: string) => void;
  options: string[];
}
function FacetSelect(t0) {
  const $ = _c(5);
  const {
    categoryLabel,
    value,
    onValueChange,
    options
  } = t0;
  let t1;
  if ($[0] !== categoryLabel || $[1] !== onValueChange || $[2] !== options || $[3] !== value) {
    t1 = <LabeledSelect label={categoryLabel} value={value} onValueChange={onValueChange} options={options} placeholder={categoryLabel} className="w-full" matchTriggerWidth={true} />;
    $[0] = categoryLabel;
    $[1] = onValueChange;
    $[2] = options;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export { FacetSelect };